import React, { useEffect, useMemo, useState } from 'react'
import { FormCustom, Input, Select, TextArea } from '../../Components/Form/Form'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button'

const SmsCampaignForm = ({ onSubmit, loadSubmit }) => {
  const [row, setRow] = useState({
    p_name_campaign: '',
    p_message_text: '',
    p_scheduled_at: Helpers.date.getToday({ format: '%Y-%m-%d %H:%i' }),
    p_program: false,
    p_id_country: '',
    p_status: 1,
    p_min_points: 1,
    p_id_plan: '',
    p_select_all: false,
  })
  console.log('row.p_scheduled_at', row.p_scheduled_at)
  const [countries, setCountries] = useState([])
  const [plans, setPlans] = useState([])
  const [candidates, setCandidates] = useState([])
  const [selected, setSelected] = useState({})
  const [loadingCandidates, setLoadingCandidates] = useState(false)

  useEffect(() => {
    Controllers.country.get_country().then(res => setCountries(res.data || [])).catch(req => Helpers.promise.catch({ req, toast }))
    Controllers.sms_campaign.plans().then(res => setPlans(res.data || [])).catch(req => Helpers.promise.catch({ req, toast }))
  }, [])

  const loadCandidates = () => {
    // Validación: País, Estado y Mín. puntos son obligatorios para previsualizar
    const missingCountry = !row.p_id_country
    const missingStatus = row.p_status === '' || row.p_status === null || typeof row.p_status === 'undefined'
    const missingMinPoints = row.p_min_points === '' || row.p_min_points === null || typeof row.p_min_points === 'undefined'
    if (missingCountry || missingStatus || missingMinPoints) {
      Helpers.toast.construct({ response: 'warning', message: 'País, Estado y Mín. puntos son obligatorios para previsualizar', toast })
      return
    }

    if (row.p_min_points < 1) {
      Helpers.toast.construct({ response: 'warning', message: 'Mín. puntos debe ser mayor a 0', toast })
      return
    }

    setLoadingCandidates(true)
    Controllers.sms_campaign.recipients({
      p_id_country: row.p_id_country || undefined,
      p_status: row.p_status,
      p_min_points: row.p_min_points || undefined,
      p_id_plan: row.p_id_plan || undefined,
    }).then(res => {
      const list = res.data || []
      setCandidates(list)
      // No seleccionar por defecto al previsualizar
      setSelected({})
    }).catch(req => Helpers.promise.catch({ req, toast }))
    .finally(() => setLoadingCandidates(false))
  }

  const selectedCount = useMemo(() => Object.values(selected).filter(Boolean).length, [selected])

  const handleSubmit = () => {
    if (!row.p_name_campaign || !row.p_message_text) {
      Helpers.toast.construct({ response: 'warning', message: 'Nombre y Mensaje son obligatorios', toast })
      return
    }

    const payload = { ...row }
    // Si no programa, forzar fecha actual (envío inmediato)
    if (row.p_program) {
      payload.p_scheduled_at = row.p_scheduled_at + ':00'
    } else {
      payload.p_scheduled_at = ''
    }
    if (!row.p_select_all) {
      payload.p_selected_ids = Object.keys(selected).filter(k => selected[k])
      if (payload.p_selected_ids.length === 0) {
        Helpers.toast.construct({ response: 'warning', message: 'Seleccione al menos un destinatario', toast })
        return
      }
    }

    onSubmit({ data: payload })
  }

  return <ReactPlaceholder ready rows={10}>
    <FormCustom onSubmit={handleSubmit} loadSubmit={loadSubmit}>
      <Input
        classNameParent="col-12 mb-3"
        text="Nombre de campaña"
        placeholder="Ej. Promoción"
        required
        onChange={e => setRow({ ...row, p_name_campaign: e.currentTarget.value })}
      />
      <TextArea
        classNameParent="col-12 mb-3"
        text="Mensaje"
        rows={4}
        required
        onChange={e => setRow({ ...row, p_message_text: e.currentTarget.value })}
      />
      <div className="col-12 mb-3 d-flex align-items-center">
        <input id="program_check" type="checkbox" className="mr-2" checked={row.p_program} onChange={e => setRow({ ...row, p_program: e.currentTarget.checked })} />
        <label htmlFor="program_check" className="mb-0 mr-3">Programar envío</label>
        <small className="text-muted">Si no programas, la campaña se enviará de inmediato</small>
      </div>
      {row.p_program && <Input
        classNameParent="col-12 mb-3"
        text="Fecha y hora de envío"
        type="datetime-local"
        value={row.p_scheduled_at}
        onChange={e => setRow({ ...row, p_scheduled_at: e.currentTarget.value.replace('T',' ') })}
      />}

      <div className="col-12 mb-2"><strong>Filtros</strong></div>
      <Select
        classNameParent="col-md-3 col-12 mb-3"
        text="País"
        options={countries.map(c => ({ label: c.name_country, value: c.id_country }))}
        value={row.p_id_country ? { label: (countries.find(c => c.id_country===row.p_id_country)||{}).name_country, value: row.p_id_country } : ''}
        onChange={e => {
          setRow(prev => ({ ...prev, p_id_country: e?.value || '', p_select_all: false }))
          setCandidates([])
          setSelected({})
        }}
      />
      <Select
        classNameParent="col-md-3 col-12 mb-3"
        text="Estado"
        options={[{label:'Activo', value:1},{label:'Inactivo', value:0}]}
        value={{ label: row.p_status===1?'Activo':'Inactivo', value: row.p_status }}
        onChange={e => {
          setRow(prev => ({ ...prev, p_status: e.value, p_select_all: false }))
          setCandidates([])
          setSelected({})
        }}
      />
      <Input
        classNameParent="col-md-3 col-12 mb-3"
        text="Mín. puntos (periodo actual)"
        placeholder="Min. 1"
        type="number"
        value={row.p_min_points}
        min="1"
        step="1"
        onChange={e => {
          setRow({ ...row, p_min_points: e.currentTarget.value, p_select_all: false })
          setCandidates([])
          setSelected({})
        }}
      />
      <Select
        classNameParent="col-md-3 col-12 mb-3"
        text="Rango"
        options={plans.map(p => ({ label: p.name_plan, value: p.id_plan }))}
        value={row.p_id_plan ? { label: (plans.find(p => p.id_plan===row.p_id_plan)||{}).name_plan, value: row.p_id_plan } : ''}
        onChange={e => {
          setRow(prev => ({ ...prev, p_id_plan: e?.value || '', p_select_all: false }))
          setCandidates([])
          setSelected({})
        }}
      />
      <div className="col-md-3 col-12 mb-2 d-flex align-items-end">
        <Button size="sm" variant="secondary" onClick={loadCandidates} disabled={loadingCandidates}>
          {loadingCandidates ? <i className="fa fa-circle-notch fa-spin"></i> : <><i className="fa fa-search mr-1"></i> Previsualizar</>}
        </Button>
      </div>

      <div className="col-12 mb-3 d-flex align-items-center justify-content-between">
        <div>
          <input id="select_all" type="checkbox" className="mr-2" checked={row.p_select_all} onChange={e => {
            const checked = e.currentTarget.checked
            const all = {}
            if (checked) {
              candidates.forEach(c => { all[c.id_customers] = true })
            }
            setSelected(all)
            setRow({ ...row, p_select_all: checked })
          }} />
          <label htmlFor="select_all" className="mb-0">Enviar a todos los resultados</label>
        </div>
        <div>
          <span className="badge badge-info mr-2">Resultados: {candidates.length}</span>
          <span className="badge badge-primary">Seleccionados: {row.p_select_all ? candidates.length : selectedCount}</span>
        </div>
      </div>

      <div className="col-12 mb-3" style={{ maxHeight: 320, overflow: 'auto' }}>
        <table className="table table-sm table-bordered mb-0">
          <thead className="thead-light">
            <tr>
              <th style={{width:30}}></th>
              <th>ID</th>
              <th>Cliente</th>
              <th>Teléfono</th>
              <th>Puntos</th>
            </tr>
          </thead>
          <tbody>
            {candidates.length === 0 ? <tr><td colSpan={5} className="text-center text-muted">Sin resultados. Use los filtros y presione Previsualizar.</td></tr> : candidates.map(c => {
              const checked = !!selected[c.id_customers]
              return <tr key={c.id_customers}>
                <td><input type="checkbox" checked={checked} onChange={e => {
                  const next = { ...selected, [c.id_customers]: e.currentTarget.checked }
                  setSelected(next)
                  if (!e.currentTarget.checked) {
                    if (row.p_select_all) setRow({ ...row, p_select_all: false })
                  } else {
                    const allChecked = candidates.length > 0 && candidates.every(x => !!next[x.id_customers])
                    if (allChecked && !row.p_select_all) setRow({ ...row, p_select_all: true })
                  }
                }} /></td>
                <td>{c.id_customers}</td>
                <td>{c.full_name}</td>
                <td>{c.phone}</td>
                <td>{c.points}</td>
              </tr>
            })}
          </tbody>
        </table>
      </div>
    </FormCustom>
  </ReactPlaceholder>
}

SmsCampaignForm.defaultProps = {
  onSubmit: () => {},
  loadSubmit: false,
}

export default SmsCampaignForm


